import React, { useState, useCallback, useEffect } from 'react';
import {
    ReactFlow,
    ReactFlowProvider,
    Background,
    Controls,
    applyEdgeChanges,
    applyNodeChanges,
    addEdge,
    MiniMap,
    useNodesState,
    useEdgesState,
    Position,
    Panel,
    useReactFlow,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import TextUpdaterNode from './TextUpdaterNode.js';
import './text-updater-node.css';
import './FlowEngine.css';
import Dagre from '@dagrejs/dagre';



const getLayoutedElements = (nodes, edges, options) => {
    const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
    g.setGraph({ rankdir: options.direction });

    edges.forEach((edge) => g.setEdge(edge.source, edge.target));
    nodes.forEach((node) =>
        g.setNode(node.id, {
            ...node,
            width: node.measured?.width ?? 0,
            height: node.measured?.height ?? 0,
        }),
    );

    Dagre.layout(g);

    return {
        nodes: nodes.map((node) => {
            const position = g.node(node.id);
            // We are shifting the dagre node position (anchor=center center) to the top left
            // so it matches the React Flow node anchor point (top left).
            const x = position.x - (node.measured?.width ?? 0) / 2;
            const y = position.y - (node.measured?.height ?? 0) / 2;

            return { ...node, position: { x, y } };
        }),
        edges,
    };
};



const LayoutFlow = ({
    props_nodes,
    default_props_nodes = [],
    props_edges,
    default_props_edges = [],
    onLayoutNodesChange = () => { },
    onLayoutEdgesChange = () => { },
    onLayoutNodeSelect = () => { },
    onLayoutNodeClick = () => { },
    onLayoutNodePositionChange = () => { },
}) => {
    const { fitView } = useReactFlow();
    // const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    // const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

    const nodeDefaults = {
        // sourcePosition: Position.Right,
        // targetPosition: Position.Left,
        sourcePosition: Position.Bottom,
        targetPosition: Position.Top,
    };

    const [nodes, setNodes] = useState(props_nodes ? props_nodes : default_props_nodes);
    const [edges, setEdges] = useState(props_edges ? props_edges : default_props_edges);

    const onNodesChange = useCallback(
        (changes) => {
            setNodes((nds) => applyNodeChanges(changes, nds))
        },
        [setNodes],
    );
    const onEdgesChange = useCallback(
        (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
        [setEdges],
    );
    const onConnect = useCallback(
        (params) => {
            setEdges((eds) => addEdge({
                ...params,
                animated: true,
                type: 'step',
            }, eds))
        },
        [],
    );



    useEffect(() => {
        setNodes(props_nodes)
    }, [props_nodes])
    useEffect(() => {
        setEdges(props_edges)
    }, [props_edges])
    useEffect(() => {
        onLayoutNodesChange(nodes)
    }, [nodes])
    useEffect(() => {
        onLayoutEdgesChange(edges)
    }, [edges])


    const rfStyle = {
        backgroundColor: '#FFFFFF',
    };
    // we define the nodeTypes outside of the component to prevent re-renderings
    // you could also use useMemo inside the component
    const nodeTypes = { textUpdater: TextUpdaterNode };

    const onLayout = useCallback(
        (direction) => {
            const layouted = getLayoutedElements(nodes, edges, { direction });

            setNodes([...layouted.nodes]);
            setEdges([...layouted.edges]);

            window.requestAnimationFrame(() => {
                fitView();
            });
        },
        [nodes, edges],
    );


    return (
        <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            onSelectionChange={(click_data) => {
                onLayoutNodeSelect(click_data)
            }}
            onNodeClick={(node) => {
                onLayoutNodeClick(node)
            }}
            onNodeDragStop={(node, nodes) => {
                onLayoutNodePositionChange(nodes)
            }}
            fitView
        >
            <Background />
            <Controls />
            <MiniMap
                style={{ width: 100, height: 100 }} // 調整 MiniMap 的大小
            />
            {/* <Panel position="top-right">
                <button onClick={() => onLayout('TB')}>vertical layout</button>
                <button onClick={() => onLayout('LR')}>horizontal layout</button>
            </Panel> */}
        </ReactFlow>
    );
};



const FlowEngine = ({
    custom_nodes,
    default_custom_nodes = [],
    custom_edges,
    default_custom_edges = [],
    onFlowNodesChange = () => { },
    onFlowEdgesChange = () => { },
    onFlowNodeSelect = () => { },
    onFlowNodeClick = () => { },
    onFlowNodePositionChange = () => { },
}) => {

    const [flow_nodes, set_flow_nodes] = useState(custom_nodes ? custom_nodes : default_custom_nodes);
    const [flow_edges, set_flow_edges] = useState(custom_edges ? custom_edges : default_custom_edges);

    useEffect(() => {
        set_flow_nodes(custom_nodes)
    }, [custom_nodes])
    useEffect(() => {
        set_flow_edges(custom_edges)
    }, [custom_edges])
    useEffect(() => {
        onFlowNodesChange(flow_nodes)
    }, [flow_nodes])
    useEffect(() => {
        onFlowEdgesChange(flow_edges)
    }, [flow_edges])

    return (
        <>
            <div style={{ height: '50vh' }}>
                {/* <div className='flow-display'> */}
                <ReactFlowProvider>
                    <LayoutFlow
                        props_nodes={flow_nodes}
                        props_edges={flow_edges}
                        onLayoutNodesChange={(nodes) => {
                            onFlowNodesChange(nodes)
                        }}
                        onLayoutEdgesChange={(edges) => onFlowEdgesChange(edges)}
                        onLayoutNodeSelect={(click_data) => onFlowNodeSelect(click_data)}
                        onLayoutNodeClick={(node) => onFlowNodeClick(node)}
                        onLayoutNodePositionChange={(nodes) => onFlowNodePositionChange(nodes)}
                    />
                </ReactFlowProvider>
                {/* </div> */}
            </div>
        </>
    );
}

export default FlowEngine;
